import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Tabs,
  Tab,
  Tooltip,
  TextField,
  CircularProgress,
  Avatar,
  IconButton,
  Toolbar,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  AppBar,
  InputAdornment,
  Modal,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Card,
  CardContent,
  Grid,
  Breadcrumbs,
  Link,
} from "@mui/material";
import { CalendarToday, Notifications, Search } from "@mui/icons-material";
import { InfoOutlined } from "@mui/icons-material";
import { Button, ModalClose, Sheet, Stack } from "@mui/joy";
import EditIcon from "@mui/icons-material/Edit";
import { OrderManagementProductModal, VendorappBar } from "../../../components";

import { BASE_URL_TEST } from "../../../utils/baseUrl";
import { urls } from "../../../urls/urls";
import { useFetch,useFetchById,usePut } from "../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { setModalProperties } from "../../../store/actions/userActions";
import { styled } from "@mui/system";

import { convertToLocalTime,formatDateTime } from "../../../utils/DateFormats";

const initialOrderData = [
  {
    id: "#6548",
    created: "2 min ago",
    customer: "Joseph Wheeler",
    total: "₹654",
    profit: "₹154",
    profitPercent: "16%",
    status: "Pending",
    trackingNumber: "TN001",
  },
  {
    id: "#6549",
    created: "10 min ago",
    customer: "Michael Smith",
    total: "₹854",
    profit: "₹254",
    profitPercent: "20%",
    status: "Confirmed",
    trackingNumber: "TN002",
  },
  {
    id: "#6550",
    created: "15 min ago",
    customer: "Anna Johnson",
    total: "₹354",
    profit: "₹54",
    profitPercent: "8%",
    status: "Processing",
    trackingNumber: "TN003",
  },
  {
    id: "#6551",
    created: "20 min ago",
    customer: "Chris Lee",
    total: "₹554",
    profit: "₹154",
    profitPercent: "15%",
    status: "Picked",
    trackingNumber: "TN004",
  },
  {
    id: "#6552",
    created: "25 min ago",
    customer: "Jessica Brown",
    total: "₹754",
    profit: "₹254",
    profitPercent: "25%",
    status: "Shipped",
    trackingNumber: "TN005",
  },
];


const StyledButton = styled(Button)({
    background: "linear-gradient(to right, #ff416c, #ff4b2b)",
    color: "#fff",
    padding: "12px 0",
    fontSize: "16px",
    fontWeight: "bold",
    borderRadius: "30px",
    marginTop: "20px",
    textTransform: "none",
    ":hover": {
      background: "linear-gradient(to right, #F4511E, #E64A19)",
    },
  });


const statusColors = {
  Pending: "#fbf2d3",
  Confirmed: "#fbf2d3",
  Processing: "#fbf2d3",
  Picked: "#fbf2d3",
  Shipped: "#fbf2d3",
  Delivered: "#fbf2d3",
  Cancelled: "#fbf2d3",
};

const OrderManagement = ({onBackScreenName}) => {
  const dispatch=useDispatch();
  const [mainTab, setMainTab] = useState(1);
  const [selectedTab, setSelectedTab] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  
  const [showOTP, setShowOTP] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [viewOrder, setViewOrder] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [status, setStatus] = useState("");
  const [reason, setReason] = useState("");
  const [trackingNumber, setTrackingNumber] = useState("");
  const [orderMData, setOrderMData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [reload, setReload] = useState(0);
  const [orderData, setOrderData] = useState(initialOrderData);
  const loginToken=useSelector((state)=>state.user.logintoken);
 const userDetails = useSelector((state) => state.user.userdetails);

  const userVtype = userDetails?.vtype;

  const {id}=useSelector((state)=>state.user.userdetails)
const inputRefs = useRef([]);
  const [otp, setOtp] = useState(["1", "2", "3", "4", "5", "6"]);
const userDetailsState=useSelector((state)=>state.user.userdetails);

 const statuses = [
  { label: "PENDING", value: "PENDING" },
  { label: "Confirmed", value: "Confirmed" },
  { label: "Processing", value: "Processing" },
  { label: "Picked", value: "Picked" },
  { label: "Shipped", value: "Shipped" },
  { label: "Delivered", value: "Delivered" },
  { label: "Cancelled", value: "Cancelled" },
  { label: "Site-Admin", value: "Site-Admin" },
  { label: "Returned", value: "Returned" }
];


      const {data:ordersData,error:ordersDataError,fetchDataById:fetchOrdersData} = useFetchById(BASE_URL_TEST,{
                                      method: 'GET',
                                      headers: { 
                                          'Content-Type': 'application/json',
                                          "Authorization":loginToken ? `Bearer ${loginToken}`:''
                                      }
                                    })
      const {data:statusesData,error:statusesDataError,fetchDataById:fetchStatusData} = useFetchById(BASE_URL_TEST,{
                                      method: 'GET',
                                      headers: { 
                                          'Content-Type': 'application/json',
                                          "Authorization":loginToken ? `Bearer ${loginToken}`:''
                                      }
                                    })

      const {data:regularOrderStatusData,error:regularOrderStatusDataError,putData:regularOrderStatusPutData} = usePut(BASE_URL_TEST+"/"+urls('cancelOrder'),{
                                      method: 'PUT',
                                      headers: { 
                                          'Content-Type': 'application/json',
                                          "Authorization":loginToken ? `Bearer ${loginToken}`:''
                                      }
                                    })
      const {data:orderStatusData,error:orderStatusDataError,putData:orderStatusPutData} = usePut(BASE_URL_TEST+"/"+urls('cancelOrderListing'),{
                                      method: 'PUT',
                                      headers: { 
                                          'Content-Type': 'application/json',
                                          "Authorization":loginToken ? `Bearer ${loginToken}`:''
                                      }
                                    })



  const handleEditClick = (order) => {
    console.log("pen clicked",order);
    setSelectedOrder(order);
    setTrackingNumber(order.trackingNumber);
    // setStatus(order.status);
    setOpen(true);
   
  };


  const handleUpdateOrder = () => {
    if ((status === "Cancelled" || status === "Site-Admin") && !reason.trim()) {
      alert("Please provide a reason before updating the status.");
      return;
    }
    console.log("ordered data 206",selectedOrder);
    // const updatedOrders = orderData.map((order) => {
    //   if (order.id === selectedOrder.id) {
    //     return { ...order, status, trackingNumber };
    //   }
    //   return order;
    // });
    // setOrderData(updatedOrders);

    console.log("payload",{
    "cart_id": selectedOrder.cart_id,
    "vendor_id": selectedOrder.vendor_id,
    "order_status": status,
     "customer_id": selectedOrder?.cart?.user_id,
    "previous_status": selectedOrder?.order_status
})

if(userDetailsState?.vtype=="vlistuser"){
orderStatusPutData({
    "cart_id": selectedOrder.cart_id,
    "vendor_id": selectedOrder.vendor_id,
    "order_status": status,
     "customer_id": selectedOrder?.cart?.user_id,
    "previous_status": selectedOrder?.order_status,
    ...(reason.trim() && { "reason": reason.trim() })
})
}else if(userDetailsState?.vtype=="vendor"){

regularOrderStatusPutData({
    "cart_id": selectedOrder.cart_id,
    "vendor_id": selectedOrder.vendor_id,
    "order_status": status,
     "customer_id": selectedOrder?.cart?.user_id,
    "previous_status": selectedOrder?.order_status,
    ...(reason.trim() && { "reason": reason.trim() })
})
  };
}
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };



  useEffect(()=>{
          const catByIdUrl = urls("getStatusById",id);
           fetchStatusData(catByIdUrl);
  },[selectedOrder])

  useEffect(()=>{
    //const catByIdUrl = urls("getOrdersByVendorId",id);
     const catByIdUrl = urls(userDetailsState?.vtype=="vlistuser"? "getOrdersByLVendorId":"getOrdersByVendorId",userDetailsState?.id);
       
           fetchOrdersData(catByIdUrl);
        
           
  },[id,reload==1])



  useEffect(()=>{
   if(ordersDataError){

   }
   else if(ordersData && ordersData['status']==true){
    console.log("orderdata",ordersData['data'])
      setOrderMData(ordersData['data'])
      
   }
   else if(ordersData && ordersData['status']===false){
   }
  },[ordersData,ordersDataError])

  var PendingFilteredData=orderMData.filter((item)=>item.order_status==="PENDING")
  

  const ConfirmedFilteredData=orderMData.filter((item)=>item.order_status==="Confirmed")

  const ProcessingFilteredData = orderMData.filter(o => o.order_status === "Processing");
const PickedFilteredData = orderMData.filter(o => o.order_status === "Picked");
const ShippedFilteredData = orderMData.filter(o => o.order_status === "Shipped");
const DeliveredFilteredData = orderMData.filter(o => o.order_status === "Delivered");
const CancelledFilteredData = orderMData.filter(o => o.order_status === "Cancelled");

  console.log("PendingFilteredData",PendingFilteredData);


  const tabDataMap = {
  0: PendingFilteredData,
  1: ConfirmedFilteredData,
  2: ProcessingFilteredData,
  3: PickedFilteredData,
  4: ShippedFilteredData,
  5: DeliveredFilteredData,
  6: CancelledFilteredData,
};

// Resolve the actual delivery address for this order
const primaryAddress = selectedOrder?.cart?.customerDetails?.addresses?.find(
  (a) => a.is_primary === 1
) || selectedOrder?.cart?.customerDetails?.addresses?.[0];

const deliveryLat = primaryAddress?.latitude;
const deliveryLng = primaryAddress?.longitude; 

  useEffect(()=>{
   if(statusesDataError){

   }
   else if(statusesData && statusesData['status']==true){
    console.log("statusesData",statusesData['data'])
      setStatusData(statusesData['data'])
      
   }
   else if(statusesData && statusesData['status']===false){
   }
  },[statusesData,statusesDataError])

  const handleMainTabChange = (event, newValue) => {
    setMainTab(newValue);
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const filteredOrders = orderMData.filter((order) =>
    order.cart_number?.toLowerCase().includes(searchValue.toLowerCase())
  );
  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  const getOrderStatusColor=(orderStatus)=>{
    
      if(orderStatus==="PENDING"){
        return '#81470E';
      }
      else if(orderStatus==="Confirmed"){
        return '#187B14';

      }
      else if(orderStatus==="Cancelled"){
        return '#810E0E';

      }
      else if(orderStatus==="Processing"){
        return '#741B68';

      }

      
    
    
  }


  const hanldeViewProduct=(product)=>{
    setOpenModal(!openModal)
    console.log("product data",product)
    setViewOrder(product)
  }

  const handleModalClose=()=>{
    setOpenModal(!openModal);
  }

  const handleOrderStatus=(buttonType,product)=>{
    console.log("cartid",product)
    console.log("cartid vid 364",product.vendor_id)
    orderStatusPutData({
    "cart_id": product.cart_id,
    "vendor_id": product.vendor_id,
    "order_status": buttonType,
    "customer_id": product?.cart?.customerDetails?.user_id,
    "previous_status": product?.order_status
})
 }


 useEffect(()=>{
  if(orderStatusDataError){

  }else if(orderStatusData && orderStatusData['status']===true){
    console.log("selectedTab resp",selectedTab)
    if(selectedTab===1 || selectedTab===0){
      setReload(1)
    }
    else {setReload(0)}
    //setOpen(false);
       dispatch(
          setModalProperties({
            showModal: true,
            modalMessage:orderStatusData['message']
          })
        );


  }

 },[orderStatusData,orderStatusDataError])


 useEffect(()=>{
  if(regularOrderStatusDataError){

  }else if(regularOrderStatusData && regularOrderStatusData['status']===true){
    console.log("selectedTab resp",selectedTab)
    if(selectedTab===1 || selectedTab===0){
      setReload(1)
    }
    else {setReload(0)}
    setOpen(false);
       dispatch(
          setModalProperties({
            showModal: true,
            modalMessage:regularOrderStatusData['message']
          })
        );


  }

 },[regularOrderStatusData,regularOrderStatusDataError])



 const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        bgcolor: "#EEF2FF",
        p: 3,
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* <AppBar
        position="static"
        elevation={0}
        sx={{
          borderBottom: "1px solid #ddd",
          backgroundColor: "white",
          color: "black",
          borderRadius: "20px",
        }}
      >
        <Toolbar>
          <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
            Order Management
          </Typography>
          <IconButton>
            <CalendarToday />
          </IconButton>
          <Typography variant="body1" sx={{ mx: 2 }}>
            28 Dec, 2024
          </Typography>
          <IconButton>
            <Notifications />
          </IconButton>
          <Avatar alt="Gn" src="/profile.webp" />
        </Toolbar>
      </AppBar> */}
      <VendorappBar title={" Order Management"} onBackScreenName={handleScreeName}/>

      {/* Main Tabs for New Orders and Order Status */}
      <Tabs value={mainTab} onChange={handleMainTabChange} sx={{ mb: 0,display:'none' }}>
        <Tab
          label="New Orders"
          sx={{ color: mainTab === 0 ? "#4F46E5" : "inherit",display:'none' }}
        />
        <Tab
          label="Order Status"
          sx={{ color: mainTab === 1 ? "#4F46E5" : "inherit" }}
        />
      </Tabs>

      {mainTab === 0 ? (
        <Box sx={{ padding: 3 }}>
          {/* Breadcrumbs */}
          <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: 0 }}>
            <Link underline="hover" color="inherit" href="#">
              Home
            </Link>
            <Link underline="hover" color="inherit" href="#">
              Order Management
            </Link>
            <Typography color="text.primary">New Orders</Typography>
          </Breadcrumbs>

          {/* Accept All Button */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
            <Button variant="outlined" color="success">
              Accept All
            </Button>
          </Box>

          {/* Order Cards */}
          {/* old */}
          <Grid container spacing={3} >
            {orderMData&& Array.isArray(orderMData) && orderMData.length>0 ?
            orderMData.map((order) => (
              <Grid item xs={12} key={order.cart_id}>
                <Card
                  sx={{
                    padding: 2,
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "20px",
                  }}
                >
                  {/* Image placeholder */}
                  <Box
                    
                 
                 
                  />
                   <img
             src={order?.items[0]?.listing?.images[0]}
            alt="product-img"
            style={{
              width: 80,
              height: 80,
              objectFit: "cover",
              borderRadius: 6,
            }}
          />
                  {/* Order details */}
                 <CardContent sx={{ flex: 1 }}>
              <Typography variant="body2" sx={{ mb: 2 }}>
                {order?.cart_number}
              </Typography>
             
              <Typography variant="body2" color="text.secondary">
                Order Status:  <b style={{color:getOrderStatusColor(order.order_status)}}>{order?.order_status}</b>
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Payment: {order.cart?.payment_method}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Distance: {order.distance}
              </Typography>
                 </CardContent>

                  {/* Total and Action Buttons */}
                  <Box sx={{ textAlign: "right" }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      Grand Total
                    </Typography>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                      {order?.total_amount}
                    </Typography>
                    <Stack direction="row" spacing={1}> 
                      <Button variant="solid" color="primary" onClick={()=>hanldeViewProduct(order)} onbut>
                        View
                      </Button>
                      <Button variant="outlined" color="danger" onClick={()=>handleOrderStatus("Cancelled",order)}>
                        Reject
                      </Button>
                      <Button variant="solid" color="success" onClick={()=>handleOrderStatus("Confirmed",order)}>
                        Accept
                      </Button>
                    </Stack>
                  </Box>
                </Card>

                
              </Grid>
            )):
            <Typography variant="h6" sx={{display:'flex',width:'100%',justifyContent:'center'}}>
              No Orders Found
              </Typography>}
          </Grid>


 
<OrderManagementProductModal onClose={()=>handleModalClose()} open={openModal} order={viewOrder}  />

        </Box>
      ) : (
        <Box
          component="main"
          sx={{ flexGrow: 1, bgcolor: "#EEF2FF", p: 3, overflowY: "auto" }}
        >
          <Tabs value={selectedTab} onChange={handleTabChange} sx={{ mb: 2 }}>
            <Tab
              label="Pending"
              sx={{ color: selectedTab === 0 ? "#4F46E5" : "inherit" }}
            />
            <Tab
              label="Confirmed"
              sx={{ color: selectedTab === 1 ? "#4F46E5" : "inherit" }}
            />
            <Tab
              label="Processing"
              sx={{ color: selectedTab === 2 ? "#4F46E5" : "inherit" }}
            />
            <Tab
              label="Picked"
              sx={{ color: selectedTab === 3 ? "#4F46E5" : "inherit" }}
            />
            <Tab
              label="Shipped"
              sx={{ color: selectedTab === 4 ? "#4F46E5" : "inherit" }}
            />
            <Tab
              label="Delivered"
              sx={{ color: selectedTab === 5 ? "#4F46E5" : "inherit" }}
            />
            <Tab
              label="Cancelled"
              sx={{ color: selectedTab === 6 ? "#4F46E5" : "inherit" }}
            />
          </Tabs>

          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <TextField
              placeholder="Search by order id"
              variant="outlined"
              size="small"
              value={searchValue}
              onChange={handleSearchChange}
              sx={{ width: "300px" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          {/* Orders Table */}
          <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ORDER ID</TableCell>
                  <TableCell>TRACKING NUMBER</TableCell>
                  <TableCell>CREATED</TableCell>
                  <TableCell>CUSTOMER</TableCell>
                  <TableCell>TOTAL</TableCell>
                  <TableCell>PAYMENT TYPE</TableCell>
                  <TableCell>STATUS</TableCell>
                  <TableCell align="right">ACTIONS</TableCell>
                </TableRow>
              </TableHead>
          <TableBody>
  {tabDataMap[selectedTab] && tabDataMap[selectedTab].filter(o => o.cart_number?.toLowerCase().includes(searchValue.toLowerCase())).length > 0 ? (
    tabDataMap[selectedTab].filter(o => o.cart_number?.toLowerCase().includes(searchValue.toLowerCase())).map((item) => (
      <TableRow key={item.cart_id}>
        <TableCell>{item.cart_number}</TableCell>
        <TableCell>{item?.cart?.transaction_id}</TableCell>
        <TableCell>{formatDateTime(item?.createdAt)}</TableCell>
        <TableCell>
          {item?.cart?.customerDetails?.first_name}{" "}
          {item?.cart?.customerDetails?.last_name}
        </TableCell>
        <TableCell>{item?.total_amount}</TableCell>
        <TableCell>{item?.cart?.payment_method}</TableCell> 
        <TableCell>{item?.order_status}</TableCell>

        {/* ACTIONS CELL */}
        <TableCell align="right">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor:'pointer'
            }}
            onClick={() => setOpen(true)}
          >
            <EditIcon onClick={() => handleEditClick(item)} />
          </Box>

          {/* EDIT MODAL */}
          <Modal
            aria-labelledby="modal-title"
            aria-describedby="modal-desc"
            open={open}
            onClose={() => { setOpen(false); setReason(""); }}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            BackdropProps={{
              style: { backgroundColor: "rgba(0, 0, 0, 0.2)" },
            }}
          >
            <Sheet
              variant="outlined"
              sx={{
                maxWidth: "700px",
                width: "100%",
                borderRadius: "md",
                p: 3,
              }}
            >
              <ModalClose
                variant="plain"
                sx={{ m: 1 }}
                onClick={() => { setOpen(false); setReason(""); }}
              />

              <Typography
                sx={{
                  fontSize: 20,
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                Edit Order Status
              </Typography>

              <Box
  sx={{
    maxHeight: "70vh",   // adjust as needed
    overflowY: "auto",
    paddingRight: 1,     // prevents content from hiding behind scrollbar
  }}
>

 {
              selectedOrder && (
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >

                   <Box mb={3} p={2} bgcolor="#f5f5f5" borderRadius={2}>
                                  <Typography variant="body1" mb={1}>
                                    <strong>Order ID:</strong> # {selectedOrder.cart_number}
                                  </Typography>
                                  {/* <Typography variant="body1" mb={1}>
                                    <strong>Item:</strong> {selectedInvoiceData.orderItem}
                                  </Typography> */}
                                  <Typography variant="body1" mb={1}>
                                    <strong>Date:</strong> {formatDateTime(selectedOrder?.createdAt)}
                                  </Typography>
                                </Box>
                  {/* <Typography variant="body1" gutterBottom display={"none"}>
                    <span style={{ fontWeight: "bold" }}>Order IiiD:</span>{" "}
                    {selectedOrder.cart_number}
                  </Typography>
                  <Typography variant="body1" gutterBottom display={"none"}>
                    <span style={{ fontWeight: "bold" }}>Created:</span>{" "}
                    {selectedOrder?.cart?.created_at}
                  </Typography> */}
                  <Box mb={3} p={2} bgcolor="#f5f5f5" borderRadius={2}>
                                  <Typography variant="body1" mb={1}>
                                    <strong>Customer:</strong>   {selectedOrder?.cart?.customerDetails?.first_name}{" "}
                    {selectedOrder?.cart?.customerDetails?.last_name}
                                  </Typography>
                                  {/* <Typography variant="body1" mb={1}>
                                    <strong>Item:</strong> {selectedInvoiceData.orderItem}
                                  </Typography> */}
                                  <Typography variant="body1" mb={1}>
                                    <strong>Phone Number:</strong>  {selectedOrder?.cart?.customerDetails?.phone_number}
                                  </Typography>

                                  {(selectedOrder?.cart?.customerDetails?.address || selectedOrder?.cart?.delivery_address) && (
                                    <Typography variant="body1" mb={1}>
                                      <strong>Address:</strong>{" "}
                                      {selectedOrder?.cart?.customerDetails?.address || selectedOrder?.cart?.delivery_address}
                                      {selectedOrder?.cart?.customerDetails?.city ? `, ${selectedOrder?.cart?.customerDetails?.city}` : ""}
                                      {selectedOrder?.cart?.customerDetails?.state ? `, ${selectedOrder?.cart?.customerDetails?.state}` : ""}
                                      {selectedOrder?.cart?.customerDetails?.pincode ? ` - ${selectedOrder?.cart?.customerDetails?.pincode}` : ""}
                                    </Typography>
                                  )}

                                  {(selectedOrder?.cart?.customerDetails?.latitude || selectedOrder?.cart?.customerDetails?.longitude) && (
                                    <Typography variant="body1" mb={1}>
                                      <strong>Location:</strong>{" "}
                                      {deliveryLat},{" "}
                                      {deliveryLng}
                                      {" "}
                                      <a
                                        href={`https://www.google.com/maps?q=${deliveryLat},${deliveryLng}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "#4F46E5", fontSize: "0.85rem" }}
                                      >
                                        (View on Map)
                                      </a>
                                    </Typography>
                                  )}

                                   <Typography variant="body1" gutterBottom  display={"flex"} flexDirection={"row"}>
                    <span style={{ fontWeight: "bold" }} >Distance:</span>{" "}
                    <Typography style={{color: selectedOrder?.distance>20?'red':'green'}} sx={{fontWeight:'500'}}>
                                  {selectedOrder?.distance} km
                    </Typography>
                   
                  </Typography>

                  <Typography variant="body1" gutterBottom>
                    <span style={{ fontWeight: "bold" }}>Total:</span>{" "}
                    {selectedOrder.total_amount}
                  </Typography>
                                </Box>


                  {/* <Typography variant="body1" gutterBottom>
                    <span style={{ fontWeight: "bold" }}>Customer:</span>{" "}
                    {selectedOrder?.cart?.customerDetails?.first_name}{" "}
                    {selectedOrder?.cart?.customerDetails?.last_name}
                  </Typography>
                   <Typography variant="body1" gutterBottom>
                    <span style={{ fontWeight: "bold" }}>Phone Number:</span>{" "}
                    {selectedOrder?.cart?.customerDetails?.phone_number}
                 
                  </Typography> */}

                   

                  <Typography variant="h6" fontWeight="bold" gutterBottom>
    Products
  </Typography>

  {selectedOrder?.items?.map((item, index) => (
    <Card
      key={index}
      sx={{ p: 2, mb: 2, backgroundColor: "#f5f5f5", borderRadius: 2 }}
    >
      <Typography variant="subtitle1" fontWeight="bold">
        {item.product?.name}
      </Typography>

      <Typography variant="body2" sx={{ mb: 1 }}>
        Qty: {item.quantity} | Price: ₹{item.sellingPrice}
      </Typography>

      {/* Product Images */}
      <Box sx={{ display: "flex", gap: 1, overflowX: "auto" }}>
        
        {
          userVtype==="vendor" ?
        item.product?.images?.map((img, imgIndex) => (
          <img
            key={imgIndex}
            src={img}
            alt="product-img"
            style={{
              width: 80,
              height: 80,
              borderRadius: 8,
              objectFit: "cover",
            }}
          />
        ))
        : item.listing?.images?.map((img, imgIndex) => (
          <img
            key={imgIndex}
            src={img}
            alt="product-img"
            style={{
              width: 80,
              height: 80,
              borderRadius: 8,
              objectFit: "cover",
            }}
          />
        ))
        }
      </Box>
    </Card>
  ))}

                  {/* Tracking Number Input */}
                  <FormControl fullWidth>
                    <TextField
                      label="Tracking Number"
                      variant="outlined"
                      size="small"
                      sx={{ mb: 2,display:'none' }}
                      value={trackingNumber}
                      onChange={(e) => setTrackingNumber(e.target.value)}
                    />
                  </FormControl>

                  {/* Status Dropdown */}
                  { selectedTab!=5 && selectedTab!=6 && (
                    <FormControl fullWidth>
                      <InputLabel>Status</InputLabel>
                      <Select
                        label="Status"
                        value={status}
                        onChange={(e) => { handleStatusChange(e); setReason(""); }}
                        size="small"
                        sx={{ mb: 2 }}
                      >
                        {/* {statuses.map((item) => (
                          <MenuItem key={item.value} value={item.value}>
                            {item.value}
                          </MenuItem>
                        ))} */}

                        {statuses
  .filter(item => !(item.value === "Site-Admin" && userVtype === "vlistuser"))
  .map(item => (
    <MenuItem key={item.value} value={item.value}>
      {item.value}
    </MenuItem>
))}
                      </Select>
                    </FormControl>
                  )}

                  {/* Reason Field for Cancelled / Site-Admin */}
                  {(status === "Cancelled" || status === "Site-Admin") && (
                    <FormControl fullWidth>
                      <TextField
                        label="Reason *"
                        variant="outlined"
                        size="small"
                        multiline
                        rows={3}
                        sx={{ mb: 2 }}
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        error={!reason.trim()}
                        helperText={!reason.trim() ? "Reason is required" : ""}
                      />
                    </FormControl>
                  )}

{status==='Delivered' ?
    <Card
                              sx={{ padding: 2, marginBottom: 2, backgroundColor: "#f9f9f9" }}
                        >
                           
                           
                            
                              {/* OTP Section */}
                              {status==='Delivered' && (
                                <>
                                  <IconButton
                                    onClick={() => setShowOTP(false)}
                                    sx={{ alignSelf: "flex-start", color: "white" }}
                                  >
                                    {/* <ArrowBackIcon /> */}
                                  </IconButton>
                  
                                  <Typography variant="h6" fontWeight="bold">
                                    OTP Verification
                                  </Typography>
                                  <Typography>
                                    OTP has been sent  
                                  </Typography>
                  
                                  <Box mt={3} display="flex" gap={1}>
                                    
                                    {otp.map((digit, index) => (
                                                       <TextField
                                                         key={index}
                                                         value={digit}
                                                         inputRef={(el) => (inputRefs.current[index] = el)}
                                                         variant="outlined"
                                                         sx={{
                                                           width: 50,
                                                           background: "white",
                                                           borderRadius: "8px",
                                                         }}
                                                         inputProps={{
                                                           maxLength: 1,
                                                           style: { textAlign: "center" },
                                                         }}
                                                         onChange={(e) => handleChange(e, index)}
                                                         onKeyDown={(e) => handleKeyDown(e, index)}
                                                       />
                                                     ))}
                                    
                                  </Box>
                  
                        
                  
                                
                                </>
                              )}
                            </Card>
                            : null}

                            {status === "Cancelled" || status === "Site-Admin" ? (
                              <TextField
                                label="Cancellation Reason"
                                variant="outlined"
                                size="small"
                                multiline
                                rows={3}
                                sx={{ mb: 2 }}
                                onChange={(e)=>{
                                  setReason(e.target.value)
                                }}
                              />

                            ) : null}

                    

                  {/* Update Button */}
                  { selectedTab!=5 && selectedTab!=6 &&(
  <Button
                    sx={{
                      backgroundColor: "#4F46E5",
                      alignContent: "center",
                      color: "white",
                    }}
                    onClick={handleUpdateOrder}
                  >
                    Update
                  </Button>
                  )}
                
                </Stack>
              )}

</Box>

             
            </Sheet>
          </Modal>
        </TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={8} align="center">
        <Typography variant="body2">No Data Found</Typography>
      </TableCell>
    </TableRow>
  )}
</TableBody>


            </Table>
          </TableContainer>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 2,
            }}
          >
            <Typography variant="body2">
              Showing {tabDataMap[selectedTab].length} of {tabDataMap[selectedTab].length}
            </Typography>
            <Box>
              <IconButton sx={{ color: "#4F46E5" }}>⟨</IconButton>
              {[1, 2, 3, 4, 5].map((page) => (
                <IconButton key={page} sx={{ color: "#4F46E5" }}>
                  {page}
                </IconButton>
              ))}
              <IconButton sx={{ color: "#4F46E5" }}>⟩</IconButton>
            </Box>
          </Box>
        </Box>
      )}

      
    </Box>
  );
};

export default OrderManagement;
